(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;
  const { ENEMIES_HERE } = window.RB.CardLib.sfd;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Boots of Swiftness": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] }),
      ],
      attachedKw: [["ganking", null]],
    },

    "Cull": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, play a Gold gear token exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 1, loc: "base", exhausted: true }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Doran's Ring": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: false,
          label: "When I conquer, discard 1, then draw 1",
          targets: [],
          program: [{ op: "discard", n: 1 }, { op: "draw", n: 1 }],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Downwell": {
      play: [
        { op: "toHand", spec: { type: "unit" } },
        { op: "toHand", spec: { type: "gear" } },
      ],
    },

    "Edge of Night": {
      play: [
        {
          op: "if",
          cond: { k: "fromFacedown" },
          then: [
            {
              op: "choose",
              bind: "_fd",
              spec: { type: "unit", friendly: true, here: true },
              prompt: "Attach Edge of Night to which unit here?",
            },
            { op: "attachSource", to: "$_fd" },
          ],
        },
      ],
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] }),
      ],
    },

    "Factory Recall": {
      play: [{ op: "toHand", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "gear" }, prompt: "Return to hand..." }],
    },

    "Harpoon Squad": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move from a battlefield, give me +2 :rb_might: this turn",
          targets: [],
          program: [buff("source", 2)],
          self: true,
          condSpec: { k: "evFromBf" },
        },
      ],
    },

    "Last Rites": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] }, { costRecycleTrash: 2 }),
      ],
      attachedTriggers: [
        {
          on: "conquer",
          optional: true,
          label: "When I conquer or hold, you may play a unit from your trash",
          targets: [],
          program: [
            {
              op: "choose",
              bind: "_pt",
              spec: { type: "unit", zone: "trash", affordable: true },
              prompt: "Play which unit from your trash?",
            },
            { op: "playCard", to: "$_pt" },
          ],
          selfBf: true,
          you: true,
        },
        {
          on: "hold",
          optional: true,
          label: "When I conquer or hold, you may play a unit from your trash",
          targets: [],
          program: [
            {
              op: "choose",
              bind: "_pt",
              spec: { type: "unit", zone: "trash", affordable: true },
              prompt: "Play which unit from your trash?",
            },
            { op: "playCard", to: "$_pt" },
          ],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Master Bingwen": {},

    "Treasure Hunter": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, play a Gold gear token exhausted",
          targets: [],
          program: [{ op: "token", name: "Gold", n: 1, loc: "base", exhausted: true }],
          self: true,
        },
      ],
    },

    "Black Market Broker": {
      triggers: [
        {
          on: "played",
          label: "face-down play: Gold token",
          condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evFromFacedown" }] },
          program: [{ op: "token", name: "Gold", exhausted: true }],
        },
        {
          on: "finalizedCard",
          label: "face-down spell: Gold token",
          condSpec: {
            k: "and",
            conds: [{ k: "evYou" }, { k: "evFromFacedown" }, { k: "evType", type: "spell" }],
          },
          program: [{ op: "token", name: "Gold", exhausted: true }],
        },
      ],
    },

    "Called Shot": {
      play: [{
        op: "lookTopTake", n: 2, take: "hand",
        prompt: "Draw one of the top two - the other is recycled",
      }],
      repeatCosts: [{ cost: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] } }],
    },

    "Corrupt Enforcer": {
      triggers: [
        {
          on: "move", self: true, label: "moved to a battlefield: discard 1",
          condSpec: { k: "evToBf" },
          program: [{ op: "discard", n: 1 }],
        },
        {
          on: "combatEnd", selfBf: true, label: "won a combat: draw 1",
          condSpec: {
            k: "count", cmp: "exactly", n: 0,
            spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true },
          },
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Fae Porter": {
      triggers: [{
        on: "move", self: true, optional: true,
        label: "pay Chaos to bring a unit here",
        condSpec: { k: "evToBf" },
        program: [
          {
            op: "payCost", varKey: "fpPay", skipOnFail: 2,
            cost: { energy: 0, pips: 1, anyPower: 0, domains: ["chaos"] },
          },
          {
            op: "choose", bind: "_fp",
            spec: { type: "unit", friendly: true, other: true },
            prompt: "Move which unit you control to this battlefield?",
          },
          { op: "move", to: "$_fp", dest: "here" },
        ],
      }],
    },

    "Loyal Pup": {
      triggers: [{
        on: "defend", friendlyUnit: true, optional: true,
        label: "run to the defended battlefield",
        condSpec: { k: "not", cond: { k: "showdownHere" } },
        program: [{ op: "move", to: "source", dest: "here" }],
      }],
    },

    "Overzealous Fan": {
      triggers: [{
        on: "defend", self: true, optional: true,
        label: "kill me to send an attacker home",
        program: [
          {
            op: "choose", bind: "_oz", min: 0,
            spec: { type: "unit", enemy: true, here: true, inCombat: true },
            prompt: "Send which attacking unit to its base?",
          },
          {
            op: "if", cond: { k: "targetsChosen", bind: "_oz" },
            then: [
              { op: "kill", to: "source", credit: false },
              { op: "move", to: "$_oz", dest: "base" },
            ],
          },
        ],
      }],
    },

    Temptation: {
      targets: [
        {
          bind: "t", spec: { type: "unit", enemy: true },
          prompt: "Move which enemy unit?",
        },
        {
          bind: "d", spec: { type: "unit", enemy: true, notBind: "t" },
          prompt: "Move it to the location of which unit with the same controller?",
        },
      ],
      play: [{ op: "move", to: "$t", destRef: "$d" }],
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
    },

    "Ancient Warmonger": {
      selfKwSpecs: [
        ENEMIES_HERE(1), ENEMIES_HERE(2), ENEMIES_HERE(3), ENEMIES_HERE(4),
        ENEMIES_HERE(5), ENEMIES_HERE(6), ENEMIES_HERE(7), ENEMIES_HERE(8),
      ],
    },

    "Beast Below": {
      targets: [
        {
          bind: "f", spec: { type: "unit", friendly: true, other: true },
          prompt: "Return which other friendly unit to its owner's hand?",
        },
        {
          bind: "e", spec: { type: "unit", enemy: true },
          prompt: "Return which enemy unit to its owner's hand?",
        },
      ],
      play: [
        { op: "toHand", to: "$f" },
        { op: "toHand", to: "$e" },
      ],
    },

    Windsinger: {
      play: [
        {
          op: "choose", bind: "_ws", min: 0,
          spec: { type: "unit", atBf: true, maxMight: 3, other: true },
          prompt: "Return which other unit at a battlefield (3 Might or less) to its owner's hand?",
        },
        { op: "toHand", to: "$_ws" },
      ],
    },

    "Fizz, Trickster": {
      play: [
        {
          op: "choose", bind: "_fz", min: 0,
          spec: { zone: "trash", type: "spell", maxEnergy: 3 },
          prompt: "Play which spell from your trash, ignoring its Energy cost?",
        },
        { op: "playFrom", to: "$_fz", waive: "energy", recycleAfterPlay: true },
      ],
    },

    "Irelia, Graceful": {
      auraCostMod: [{
        who: "friendly",
        what: { type: "spell" },
        targetsMatching: { type: "unit", friendly: true, tag: "Irelia" },
        energyOrPowerLess: 1,
      }],
    },

    "Sivir, Mercenary": {
      selfMightSpecs: [{ n: 2, cond: { k: "spentPowerAtLeast", n: 2 } }],
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "spentPowerAtLeast", n: 2 } }],
    },

    Switcheroo: {
      targets: [
        {
          bind: "a", spec: { type: "unit", atBf: true },
          prompt: "Swap Might: choose the first unit",
        },
        {
          bind: "b", spec: { type: "unit", atBf: true, sameLocAs: "a", notBind: "a" },
          prompt: "Swap Might: choose the second unit at that battlefield",
        },
      ],
      play: [{ op: "swapMight", a: "$a", b: "$b", dur: "turn" }],
    },

    "Vex, Cheerless": {
      auraCostMod: [
        {
          who: "friendly", what: { type: "spell" }, cond: { k: "inCombat" },
          energyLess: 1, powerLess: 1, min: 1,
        },
        {
          who: "enemy", what: { type: "spell" }, cond: { k: "inCombat" },
          energyMore: 1, powerMore: 1,
        },
      ],
    },

    "Draven, Audacious": {
      triggers: [
        {
          on: "combatEnd", selfBf: true, oncePerTurn: true,
          label: "first combat won this turn: score 1",
          condSpec: {
            k: "count", cmp: "exactly", n: 0,
            spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true },
          },
          program: [{ op: "points", n: 1 }],
        },
        {
          on: "dies", self: true, label: "died in combat: an opponent scores 1",
          condSpec: { k: "inCombat" },
          program: [{ op: "points", who: "opponent", n: 1 }],
        },
      ],
    },

    "Ezreal, Prodigy": {
      play: [
        { op: "discard", n: 1 },
        { op: "draw", n: 2 },
      ],
      auraCostMod: [
        { addCost: true, who: "friendly", requiresControl: true, energyOrPowerLess: 1 },
        { repeat: true, who: "friendly", requiresControl: true, energyOrPowerLess: 1 },
      ],
    },

    "Hard Bargain": {
      repeatCosts: [{ cost: { energy: 2, pips: 0, anyPower: 0, domains: null } }],
      targets: [{
        bind: "t", spec: { zone: "chain", type: "spell", counterable: true },
        prompt: "Counter which spell?",
      }],
      play: [
        {
          op: "option", varKey: "hb", byOpponent: true,
          prompt: "Pay :rb_energy_2: to stop Hard Bargain countering your spell?",
          options: ["Pay 2 Energy", "Let it be countered"],
        },
        {
          op: "if", cond: { k: "varEq", key: "hb", value: 0 },
          then: [
            {
              op: "payCost", who: "opponent", varKey: "hbp", skipOnFail: 1,
              cost: { energy: 2, pips: 0, anyPower: 0, domains: null },
            },
            { op: "end" },
            { op: "counter", to: "$t" },
          ],
          else: [{ op: "counter", to: "$t" }],
        },
      ],
    },

    "Jae Medarda": {
      triggers: [{
        on: "targeted",
        label: "chosen by one of your spells: draw 1",
        condSpec: { k: "evChosenBySpell", byYou: true },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Spirit Wheel": {
      triggers: [{
        on: "targeted", optional: true,
        label: "you chose a friendly unit: pay 1 and exhaust this to draw 1",
        condSpec: {
          k: "and",
          conds: [{ k: "evTargetsFriendlyUnit", byYou: true }, { k: "selfReady" }],
        },
        program: [
          { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 2 },
          { op: "exhaust", to: "source" },
          { op: "draw", n: 1 },
        ],
      }],
    },
  });
})();
